/* Proshunter - bloc "Souvent achetes ensemble" (blocks/proshunter-fbt.liquid) */
(function () {
  if (customElements.get('proshunter-fbt')) return;

  class ProshunterFbt extends HTMLElement {
    connectedCallback() {
      this._onChange = this._onChange.bind(this);
      this._onVariant = this._onVariant.bind(this);
      this._onAdd = this._onAdd.bind(this);
      this.addEventListener('change', this._onChange);
      var btn = this.querySelector('.ph-fbt__add');
      if (btn) btn.addEventListener('click', this._onAdd);
      document.addEventListener('variant:update', this._onVariant);
      this._syncMain();
      this._update();
    }

    disconnectedCallback() {
      document.removeEventListener('variant:update', this._onVariant);
    }

    _rows() {
      return Array.prototype.slice.call(this.querySelectorAll('.ph-fbt__row'));
    }

    _fmt(cents) {
      var f = this.dataset.moneyFormat || '${{amount}}';
      var n = cents / 100;
      var m = f.match(/\{\{\s*(\w+)\s*\}\}/);
      var key = m ? m[1] : 'amount';
      var s;
      switch (key) {
        case 'amount_no_decimals': s = Math.round(n).toLocaleString('en-US'); break;
        case 'amount_with_comma_separator': s = n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); break;
        case 'amount_no_decimals_with_comma_separator': s = Math.round(n).toLocaleString('de-DE'); break;
        case 'amount_with_space_separator': s = n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/[  ]/g, ' '); break;
        case 'amount_no_decimals_with_space_separator': s = Math.round(n).toLocaleString('fr-FR').replace(/[  ]/g, ' '); break;
        default: s = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      }
      return f.replace(/\{\{\s*\w+\s*\}\}/, s);
    }

    _setImage(uid, src) {
      if (!src) return;
      var imgs = this.querySelectorAll('[data-for="' + uid + '"] img, [data-uid="' + uid + '"] .ph-fbt__thumb img');
      for (var i = 0; i < imgs.length; i++) { imgs[i].removeAttribute('srcset'); imgs[i].src = src; }
    }

    _setPrice(row, price, compare) {
      var box = row.querySelector('.ph-fbt__price');
      if (!box) return;
      var p = box.querySelector('[data-fbt-amount]');
      var c = box.querySelector('s');
      if (p) p.textContent = this._fmt(price);
      var onSale = compare > price;
      box.classList.toggle('is-sale', onSale);
      if (onSale) {
        if (!c) { c = document.createElement('s'); box.appendChild(c); }
        c.textContent = this._fmt(compare);
      } else if (c) {
        c.remove();
      }
    }

    _applyVariant(row, v) {
      row.dataset.variantId = v.id;
      row.dataset.price = v.price;
      row.dataset.compare = v.compare || 0;
      var available = v.available === true || v.available === 'true';
      if (v.image) this._setImage(row.dataset.uid, v.image);
      this._setPrice(row, Number(v.price), Number(v.compare || 0));
      var cb = row.querySelector('.ph-fbt__check');
      if (cb) { cb.disabled = !available; if (!available) cb.checked = false; }
      var so = row.querySelector('.ph-fbt__soldout');
      if (so) so.hidden = available;
    }

    _syncMain() {
      var row = this.querySelector('.ph-fbt__row--main');
      if (!row) return;
      var variants = [];
      try { variants = JSON.parse(row.dataset.variants || '[]'); } catch (e) { variants = []; }
      if (!variants.length) return;
      var section = this.closest('.shopify-section') || document;
      var input = section.querySelector('product-form-component input[name="id"]');
      var url = new URL(window.location.href);
      var wanted = input && input.value ? Number(input.value) : Number(url.searchParams.get('variant'));
      var v = null;
      for (var i = 0; i < variants.length; i++) { if (variants[i].id === wanted) { v = variants[i]; break; } }
      if (!v) { for (var j = 0; j < variants.length; j++) { if (variants[j].id === Number(row.dataset.variantId)) { v = variants[j]; break; } } }
      if (!v) v = variants[0];
      var t = row.querySelector('.ph-fbt__variant-title');
      if (t && variants.length > 1) t.textContent = v.title;
      this._applyVariant(row, v);
    }

    _onVariant() {
      var self = this;
      setTimeout(function () { self._syncMain(); self._update(); }, 0);
    }

    _onChange(e) {
      var sel = e.target.closest ? e.target.closest('.ph-fbt__select') : null;
      if (sel) {
        var row = sel.closest('.ph-fbt__row');
        var o = sel.options[sel.selectedIndex];
        if (row && o) {
          this._applyVariant(row, { id: o.value, price: o.dataset.price, compare: o.dataset.compare, available: o.dataset.available, image: o.dataset.image });
          var cb = row.querySelector('.ph-fbt__check');
          if (cb && !cb.disabled && !cb.checked) cb.checked = true;
        }
      }
      this._update();
    }

    _update() {
      var total = 0, compare = 0, n = 0, self = this;
      this._rows().forEach(function (row) {
        var cb = row.querySelector('.ph-fbt__check');
        var on = !!(cb && cb.checked && !cb.disabled);
        row.classList.toggle('is-unchecked', !on);
        var th = self.querySelector('.ph-fbt__strip-thumb[data-for="' + row.dataset.uid + '"]');
        if (th) th.classList.toggle('is-off', !on);
        if (on) {
          n++;
          var price = Number(row.dataset.price) || 0;
          total += price;
          compare += Math.max(Number(row.dataset.compare) || 0, price);
        }
      });
      var count = this.querySelector('[data-fbt-count]');
      var word = this.querySelector('[data-fbt-count-word]');
      var tot = this.querySelector('[data-fbt-total]');
      var cmp = this.querySelector('[data-fbt-compare]');
      var save = this.querySelector('[data-fbt-save]');
      if (count) count.textContent = n;
      if (word) word.textContent = n === 1 ? this.dataset.labelOne : this.dataset.labelMany;
      if (tot) tot.textContent = this._fmt(total);
      var saving = compare - total;
      if (cmp) { cmp.hidden = saving <= 0; if (saving > 0) cmp.textContent = this._fmt(compare); }
      if (save) { save.hidden = saving <= 0; if (saving > 0) save.textContent = (this.dataset.labelSave || '%s').replace('%s', this._fmt(saving)); }
      var btn = this.querySelector('.ph-fbt__add');
      if (btn && !btn.classList.contains('is-loading')) btn.disabled = n === 0;
    }

    _onAdd() {
      var self = this;
      var items = this._rows().filter(function (r) {
        var cb = r.querySelector('.ph-fbt__check');
        return cb && cb.checked && !cb.disabled;
      }).map(function (r) { return { id: Number(r.dataset.variantId), quantity: 1 }; });
      if (!items.length) return;
      var btn = this.querySelector('.ph-fbt__add');
      var msg = this.querySelector('.ph-fbt__msg');
      btn.disabled = true;
      btn.classList.add('is-loading');
      if (msg) msg.hidden = true;
      var sections = Array.prototype.slice.call(document.querySelectorAll('cart-items-component'))
        .map(function (e) { return e.dataset.sectionId; })
        .filter(Boolean);
      var body = { items: items, sections_url: window.location.pathname };
      if (sections.length) body.sections = sections.join(',');

      fetch(this.dataset.addUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok || r.data.status) {
            throw new Error(r.data.description || r.data.message || 'Erreur lors de l\'ajout au panier.');
          }
          return fetch((self.dataset.cartUrl || '/cart') + '.js', { headers: { Accept: 'application/json' } })
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  sourceId: self.id,
                  data: { source: 'proshunter-fbt', itemCount: cart.item_count, sections: r.data.sections }
                }
              }));
              var drawer = document.querySelector('cart-drawer-component');
              if (drawer && typeof drawer.open === 'function') {
                drawer.open();
              } else {
                window.location.href = self.dataset.cartUrl || '/cart';
              }
              if (msg) { msg.textContent = self.dataset.labelAdded || ''; msg.className = 'ph-fbt__msg ph-fbt__msg--ok'; msg.hidden = !msg.textContent; }
            });
        })
        .catch(function (err) {
          if (msg) { msg.textContent = err.message; msg.className = 'ph-fbt__msg ph-fbt__msg--error'; msg.hidden = false; }
        })
        .then(function () {
          btn.classList.remove('is-loading');
          self._update();
        });
    }
  }

  /* Rendered by the block when a product has no complementary products:
     fetches the "related" recommendations instead and swaps them in. */
  class ProshunterFbtFallback extends HTMLElement {
    connectedCallback() {
      var wrap = this.closest('product-recommendations') || this.parentElement;
      var url = this.dataset.url;
      if (!wrap || !url || wrap.dataset.fbtFallbackDone === 'true') return;
      wrap.dataset.fbtFallbackDone = 'true';
      var hide = function () { wrap.innerHTML = ''; wrap.classList.add('hidden'); };
      fetch(url)
        .then(function (res) { return res.ok ? res.text() : ''; })
        .then(function (html) {
          var div = document.createElement('div');
          div.innerHTML = html || '';
          var src = div.querySelector('product-recommendations[id="' + wrap.id + '"]');
          if (src && src.querySelector('proshunter-fbt')) {
            wrap.innerHTML = src.innerHTML;
          } else {
            hide();
          }
        })
        .catch(hide);
    }
  }

  customElements.define('proshunter-fbt', ProshunterFbt);
  customElements.define('proshunter-fbt-fallback', ProshunterFbtFallback);
})();
